import withNavigate from "../../../routes/withNavigate.jsx";
import WarrantyContainer from "./WarrantyContainer.jsx";
import WarrantyStore from "./WarrantyStore.js";

export default WarrantyStore(withNavigate(WarrantyContainer));
